import Context from './index';
import React, { useState } from 'react';

const LearningProvider = (props) => {

    const [learningData] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                learningData,
            }}
        >
            {props.children}
        </Context.Provider>
    );
};
export default LearningProvider;